import { XCircleIcon } from '@heroicons/react/solid';
import React from 'react';

const PlantAreaChanger = (props) => {
  return (
    <div className="flex mt-[1.1rem]">
      <select
        value={props.area.id}
        onChange={(e) => props.handleChangeArea(e, props.plant.id)}
        className="w-full bg-gray-100 bg-opacity-50 rounded border border-gray-300 focus:border-accent-500 focus:bg-transparent focus:ring-2 focus:ring-accent-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
      >
        {props.areaList.map((option) => (
          <option value={option.id} key={option.id}>
            {option.name}
          </option>
        ))}
      </select>
      <button
        type="button"
        onClick={() => props.setDropDownPlantId(null)}
        className="text-gray-500 hover:text-gray-700 ml-4"
      >
        <XCircleIcon className="w-5 l-5" />
      </button>
    </div>
  );
};

export default PlantAreaChanger;
